import { render, staticRenderFns } from "./CreateSocialMediaIconComponent.vue?vue&type=template&id=a6958790&"
import script from "./CreateSocialMediaIconComponent.vue?vue&type=script&lang=js&"
export * from "./CreateSocialMediaIconComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports